var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-background rounted-lg"},[_c('div',{staticClass:"title-resume mb-3 accent--text"},[_vm._v(" "+_vm._s(_vm.$t("finished.organizerMessage"))+" ")]),_c('div',{staticClass:"checkout-h5 accent--text",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }